import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=f845135a&scoped=true&"
import script from "./serviceDetails.vue?vue&type=script&lang=js&"
export * from "./serviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&id=f845135a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f845135a",
  null
  
)

export default component.exports